<template>
    <div class="view view-login">
        <LoginIntroduction
            @showLoginForm="showLoginAuthentication"
            v-if="show.loginIntroduction" />
        <LoginAuthentication
            @showLoginIntroduction="showLoginIntroduction"
            v-if="show.loginAuthentication" />
    </div>
</template>
<script>
    // Component imports
    import LoginIntroduction from '@/components/LoginIntroduction.vue';
    import LoginAuthentication from '@/components/LoginAuthentication.vue';

    export default {
        components: {
            LoginIntroduction,
            LoginAuthentication,
        },

        data(){
            return {
                show: {
                    loginIntroduction:   true,
                    loginAuthentication: false,
                },
            };
        },

        methods: {
            showLoginAuthentication(){
                this.show.loginIntroduction   = false;
                this.show.loginAuthentication = true;
            },

            showLoginIntroduction(){
                this.show.loginAuthentication = false;
                this.show.loginIntroduction   = true;
            },

            resize(){
                if(window.innerWidth >= 1024){
                    this.show.loginIntroduction   = true;
                    this.show.loginAuthentication = true;
                }
                else{
                    if(this.show.loginIntroduction){
                        this.show.loginAuthentication = false;
                    }
                    else if(this.show.loginAuthentication){
                        this.show.loginIntroduction   = false;
                    }
                }
            },
        },

        mounted(){
            window.addEventListener('resize', this.resize);
            this.resize();
        },

        beforeUnmount(){
            window.removeEventListener('resize', this.resize);
        },
    };
</script>
<style scoped src="@/css/views/view-login.css"></style>